import isMobile from '../../plugins/is-mobile.js';
import '../../plugins/jquery.easing.min.js';

$(".js-accordion-button").on("click", function(){
  $(this).closest(".js-accordion").toggleClass("is-open");
  $(this).closest(".js-accordion").find(".js-accordion-content").stop().slideToggle(200, "easeOutQuad");
  // $(this).next(".js-accordion-content").css({
  //   height: $(this).next(".js-accordion-content").outerHeight(true)
  // });
})
